<template >
  <div style="width: 100%; font-size: 14px;">
    <van-cell-group>
      <van-cell :title="generateCustomizeString('leaveMessage')" icon="chat">
      </van-cell>
    </van-cell-group>
    <van-cell-group>
      <van-field v-model="toCustomer" type="textarea" :placeholder="generateCustomizeString('pleaseInput')" rows="6" autosize />
    </van-cell-group>
  </div>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import { Row, Col, Icon, Button, Cell, CellGroup, Field } from 'vant'
// import request from '@/utils/request'

export default {
  name: 'ToCustomer',
  components: {
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field
  },
  data() {
    return {
      toCustomer: ''
    }
  },
  props: {
    orderDetailData: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    generateCustomizeString
  },
  created: function() {
    this.toCustomer = this.orderDetailData.to_customer_message
  }
}
</script>

<style type="text/css">
  .van-field__control {
    line-height: 24px !important;
  }
</style>
<style lang="less" scoped>
</style>
